export default __webpack_public_path__ + "static/media/Montserrat-ExtraLight.5ffa03e6.ttf";